import { render } from "./PartnerMosaic.vue?vue&type=template&id=82642f92"
import script from "./PartnerMosaic.vue?vue&type=script&lang=js"
export * from "./PartnerMosaic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__